import CustomDropzone from './CustomDropzone'

export default CustomDropzone